import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../routes/constants";
import {
  PERMISSIONS,
  usePermissionsStore,
} from "../shared/stores/permissionsStore";

type PermissionValue = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

interface PermissionGuardProps {
  requiredPermissions: PermissionValue | PermissionValue[];
  mode?: "all" | "any";
}

export const PermissionGuard = ({
  requiredPermissions,
  mode = "all",
}: PermissionGuardProps) => {
  const permissions = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];
  const grantedPermissions = usePermissionsStore((state) => state.permissions);
  const permissionResults = permissions.map((permission) =>
    grantedPermissions.includes(permission),
  );
  const hasRequiredPermission =
    mode === "any"
      ? permissionResults.some(Boolean)
      : permissionResults.every(Boolean);

  // Verifica si el usuario tiene el permiso requerido
  if (!hasRequiredPermission) {
    return <Navigate to={ROUTES.NOT_FOUND} replace />;
  }
  // Si tiene permiso, renderiza las rutas hijas
  return <Outlet />;
};
